export const ERROR_FILE_GREATER_MB = "Soubor musí být menší než %s MB.";
export const ERROR_FILE_MISMATCH_EXTENSION = "Soubor nemá požadovanou příponu %s.";
export const ERROR_FILE_MISMATCH_MIMETYPE = "Soubor není požadovaného formátu %s.";

export const ERROR_PASSWORD_IS_EQUAL_TO_THE_CURRENT = "Zadané heslo je shodné se současným.";
export const ERROR_PASSWORD_MIN_REQUIREMENTS = "Heslo nesplňuje minimální požadavky.";
export const ERROR_PASSWORDS_ARE_NOT_EQUALS = "Zadaná hesla se neshodují.";
